import React, { ReactElement } from "react";

import Container from "ui/Container/Container";
import Title from "ui/Title/Title";
import CategoriesItem from "common/Catalog/CategoriesList/components/CategoriesItem/CategoriesItem";

import { cn } from "helpers/style";
import styles from "./PopularCategories.module.scss";

type Props = {
  categories: Array<Entity.Category>;
  className?: string;
};

const PopularCategories: React.FC<Props> = ({
  categories,
  className,
}: Props): ReactElement => {
  return (
    <div className={cn([styles.popularCategories, className])}>
      <Container>
        <Title className={styles.popularCategoriesTitle} size="h2">
          Популярные категории
        </Title>

        <div className={styles.popularCategoriesGrid}>
          {categories.map((category, index) => (
            <div key={index}>
              <CategoriesItem category={category} />
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default PopularCategories;
